import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useScrollTo } from '../hooks/useScrollTo';
export default function NavLink({ to, children, className = '', onClick, ...props }) {
  const scrollTo = useScrollTo();
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();

    // Si c'est une route (commence par /), naviguer directement et scroller vers le haut
    if (to.startsWith('/')) {
      navigate(to, { replace: false });
      
      if (onClick) {
        onClick();
      }
      return;
    }

    // Sinon, traiter comme une ancre pour le scroll
    const cleanId = to.replace(/^\/?#?/, '');
    const isOnLandingPage = location.pathname === '/';

    if (!isOnLandingPage) {
      // Si on n'est pas sur la landing page, naviguer d'abord vers la landing page
      navigate(`/#${cleanId}`, { replace: false });

      // Attendre que la page se charge, puis scroller
      setTimeout(() => {
        scrollTo(to, () => {
          if (onClick) {
            onClick();
          }
        });
      }, 100);
    } else {
      // Si on est déjà sur la landing page, scroller directement
      scrollTo(to, () => {
        if (onClick) {
          onClick();
        }
      });
    }
  };

  // Déterminer l'URL à afficher dans href
  const href = to.startsWith('/') ? to : `#${to.replace(/^\/?#?/, '')}`;

  return (
    <a
      href={href}
      onClick={handleClick}
      className={className}
      {...props}
    >
      {children}
    </a>
  );
}
